import Vue from "vue";
import VueI18n from "vue-i18n";

let locale = "en";

let message = { ja: require("./ja.json") }; // default: "ja"

const language = window.navigator.language;

if (language) {
  const lang = language.toLowerCase().split("-");
  switch (lang[0]) {
    case "ja": // 日本語: ja, ja-JP
      locale = lang[0];
      break;
  }
}

message[locale] = require(`./${locale}.json`);
sessionStorage.setItem("lang", locale);
Vue.use(VueI18n);

export let i18n = new VueI18n({
  locale,
  fallbackLocale: "ja", // フォールバック言語: 日本語
  messages: message, // 必要な言語ファイルのみ設定する
  silentTranslationWarn: true,
});
